import { useDropEvent } from 'root/src/client/logic/dropEvent/hooks/useDropEvent';
import { useUserCreatorData } from 'root/src/client/logic/auth/hooks/useUser';
import { useViewershipPlatformsByDares } from 'root/src/client/logic/dropEvent/hooks/useViewershipPlatformsByDares';
import { useMemo } from 'react';
import { calculateMaxDaresByPlatform } from 'root/src/shared/util/calculateMaxDares';
import { clamp } from 'remeda';
export const useMaxDaresTotal = () => {
    const dropEvent = useDropEvent();
    const { averageCcv = 0, averageTikTokViews = 0, averageYoutubeViews = 0, averageYoutubeShortsViews = 0 } = useUserCreatorData();
    const { viewershipPlatformsByDares } = useViewershipPlatformsByDares();
    return useMemo(() => {
        if (!dropEvent) {
            return 0;
        }
        const totalMaxDares = viewershipPlatformsByDares.reduce((total, platform) => {
            const maxDares = calculateMaxDaresByPlatform({
                averageCcv,
                averageYoutubeViews,
                averageYoutubeShortsViews,
                averageTikTokViews,
                platform,
                campaign: dropEvent,
            });
            return total + maxDares;
        }, 0);
        return clamp(totalMaxDares, { min: 0, max: dropEvent.dares.length });
    }, [viewershipPlatformsByDares, dropEvent, averageCcv, averageYoutubeViews, averageTikTokViews, averageYoutubeShortsViews]);
};
